
import {
  HomeFilled,
  SettingOutlined,
  UserOutlined,
  UsergroupAddOutlined,
  DollarOutlined,
  CreditCardOutlined,
  StockOutlined,
  AppstoreOutlined,
  InsuranceOutlined,
  GlobalOutlined
} from '@ant-design/icons';
import { langPage } from "../locales";

export const menus: Array<any> = [
  {
    title: langPage?.home.name,
    name: "home",
    path: "/home",
    icon: <HomeFilled />,
    privilegeCode: 'home',
    children: []
  },
  {
    title: langPage?.mine.name,
    name: "mine",
    path: "/mine",
    icon: <AppstoreOutlined />,
    privilegeCode: '',
    children: []
  },
  {
    title: langPage?.amount.name,
    name: "amount",
    path: "/amount",
    icon: <DollarOutlined />,
    privilegeCode: "amount",
    children: [
      {
        title: langPage?.amount.userAddress.name,
        path: "/amount/userAddress",
        name: "userAddress",
        privilegeCode: "userAddress",
      },
      {
        title: langPage?.amount.recharge.name,
        path: "/amount/recharge",
        name: "recharge",
        privilegeCode: "recharge",
      },
      {
        title: langPage?.amount.withdrawal.name,
        path: "/amount/withdrawal",
        name: "withdrawal",
        privilegeCode: "withdrawal",
      },
      {
        title: langPage?.amount.balanceLog.name,
        path: "/amount/balanceLog",
        name: "balanceLog",
        privilegeCode: "balanceLog",
      },
      {
        title: "用户转账列表",
        path: "/amount/userTransfer",
        name: "userTransfer",
        privilegeCode: "userTransfer",
      },
    ]
  },
  {
    title: "全球付",
    name: "globalPay",
    path: "/globalPay",
    icon: <GlobalOutlined />,
    privilegeCode: "globalPay",
    children: [
      {
        title: "国际汇款列表",
        path: "/globalPay/internationalRemittanceList",
        name: "internationalRemittanceList",
        privilegeCode: "internationalRemittanceList",
      },
      {
        title: "国际汇款国家列表",
        path: "/globalPay/internationalRemittanceCountriesList",
        name: "internationalRemittanceCountriesList",
        privilegeCode: "internationalRemittanceCountriesList",
      },
      {
        title: "国际汇款通道列表",
        path: "/globalPay/internationalRemittanceChannelList",
        name: "internationalRemittanceChannelList",
        privilegeCode: "internationalRemittanceChannelList",
      },
      {
        title: "国际汇款通道时效列表",
        path: "/globalPay/internationalRemittanceCreditedTimesList",
        name: "internationalRemittanceCreditedTimesList",
        privilegeCode: "internationalRemittanceCreditedTimesList",
      },
      {
        title: "国际汇款限额列表",
        path: "/globalPay/internationalRemittanceLimitList",
        name: "internationalRemittanceLimitList",
        privilegeCode: "internationalRemittanceLimitList",
      },
      {
        title: "国际汇款滑点列表",
        path: "/globalPay/internationalRemittanceSlippageList",
        name: "internationalRemittanceSlippageList",
        privilegeCode: "internationalRemittanceSlippageList",
      },
      {
        title: "国际汇款货币转换列表",
        path: "/globalPay/internationalRemittanceCurrencyConversionList",
        name: "internationalRemittanceCurrencyConversionList",
        privilegeCode: "internationalRemittanceCurrencyConversionList",
      },
      {
        title: "扫码支付管理",
        path: "/globalPay/scanPay",
        name: "scanPay",
        privilegeCode: "scanPay",
        children: [
          {
            title: "消费支付通道列表",
            path: "/globalPay/scanPay/payChannelList",
            name: "payChannelList",
            privilegeCode: "payChannelList",
          },
          {
            title: "消费支付币种列表",
            path: "/globalPay/scanPay/payCurrencyList",
            name: "payCurrencyList",
            privilegeCode: "payCurrencyList",
          },
          {
            title: "消费支付配置列表",
            path: "/globalPay/scanPay/payConfigList",
            name: "payConfigList",
            privilegeCode: "payConfigList",
          },
          {
            title: "支付订单列表",
            path: "/globalPay/scanPay/payOrderList",
            name: "payOrderList",
            privilegeCode: "payOrderList",
          },
        ]
      },
    ]
  },
  {
    title: langPage?.card.name,
    name: "card",
    path: "/card",
    icon: <CreditCardOutlined />,
    privilegeCode: "card",
    children: [
      {
        title: langPage?.card.name,
        path: "/card/cardMain",
        name: "cardMain",
        privilegeCode: "cardMain",
      },
      {
        title: '实体卡申请',
        path: "/card/apply",
        name: "apply",
        privilegeCode: "apply",
      },
      {
        title: langPage?.card.product.name,
        path: "/card/product",
        name: "product",
        privilegeCode: "product",
      },
      {
        title: langPage?.card.record.name,
        path: "/card/cardRecord",
        name: "cardRecord",
        privilegeCode: "cardRecord",
      },
      {
        title: langPage?.card.transaction.name,
        path: "/card/cardTransaction",
        name: "cardTransaction",
        privilegeCode: "cardTransaction",
      },
      {
        title: '持卡人列表',
        path: "/card/holder",
        name: "holder",
        privilegeCode: "holder",
      },
      {
        title: "卡片入库数据",
        path: "/card/importCard",
        name: "importCard",
        privilegeCode: "importCard",
      },
      {
        title: "卡卡汇款",
        path: "/card/transfer",
        name: "transfer",
        privilegeCode: "transfer",
      },
      {
        title: "体验卡列表",
        path: "/card/virtualVip",
        name: "virtualVip",
        privilegeCode: "virtualVip",
      },
      {
        title: "vip卡任务列表",
        path: "/card/vipCardTask",
        name: "vipCardTask",
        privilegeCode: "vipCardTask",
      },
    ]
  },
  {
    title: langPage?.level.name,
    name: "level",
    path: "/level",
    icon: <StockOutlined />,
    privilegeCode: "level",
    children: []
  },
  {
    title: langPage?.member.user.name,
    path: "/member/user",
    icon: <UsergroupAddOutlined />,
    name: "user",
    privilegeCode: "user",
  },
  {
    title: langPage?.member.name,
    name: "member",
    path: "/member",
    icon: <UserOutlined />,
    privilegeCode: "member",
    children: [
      {
        title: langPage?.member.manager.name,
        path: "/member/manager",
        name: "manager",
        privilegeCode: "manager",
      },
      {
        title: langPage?.member.role.name,
        path: "/member/role",
        name: "role",
        privilegeCode: "role",
      },
      {
        title: '权限管理',
        path: "/member/privilege",
        name: "privilege",
        privilegeCode: "privilege",
      },
    ]
  },
  {
    title: langPage?.settings.name,
    name: "settings",
    path: "/settings",
    icon: <SettingOutlined />,
    privilegeCode: "settings",
    children: [
      {
        title: langPage?.settings.notice?.notice,
        path: "/settings/notice",
        name: "notice",
        privilegeCode: "notice",
      },
      {
        title: langPage?.settings.config?.name,
        path: "/settings/config",
        name: "config",
        privilegeCode: "config",
      },
      {
        title: langPage?.settings.email?.name,
        path: "/settings/email",
        name: "email",
        privilegeCode: "email",
      },
      {
        title: "轮播图配置",
        path: "/settings/banner",
        name: "banner",
        privilegeCode: "banner",
      },
    ]
  },
  // 保险箱  
  {
    title: "保险箱",
    name: "safeBox",
    path: "/safeBox",
    icon: <InsuranceOutlined />,
    privilegeCode: "safeBox",
    children: [
      {
        title: "交易列表",
        path: "/safeBox/transferList",
        name: "safeBoxTransferList",
        privilegeCode: "safeBoxTransferList",
      },
      {
        title: "收益列表",
        path: "/safeBox/profitList",
        name: "safeBoxProfitList",
        privilegeCode: "safeBoxProfitList",
      },
    ]
  },
];
